import { configureStore } from '@reduxjs/toolkit'

import reducer from './modules'

export default configureStore({
  reducer,
})
